module.exports = __webpack_public_path__ + "images/img_3_4-8509cb7d3d.png";